import "./inputSelect.css";
import { Tooltip } from 'react-tooltip';

const InputSelect = ({
  id,
  className,
  labelText,
  changeHandler,
  inputArr,
  defaultVal,
  disableVal,
  selectedValue,
  tooltip
}) => {
  const optionElements = Object.values(inputArr).map((item) => (
    <option key={item.id ? item.id : item} value={item.id ? item.id : item}>
      {item.name ? item.name : item}
    </option>
  ));

  return (
    <div id={id + "Input"} className={"form-input-container" + (className ? " " + className : "")}>
      <label className="form-label" htmlFor={"select-" + id + "Input"}>{labelText} </label>
      <div className="form-item-container">
        <select
          className="form-item form-type-select"
          id={"select-" + id + "Input"}
          name={"select-" + id + "Input"}
          onChange={changeHandler}
          disabled={disableVal ? disableVal : false}
          value={selectedValue}
          data-tooltip-id={"select-" + id + "tooltip"}
          data-tooltip-content={tooltip}
        >
          {!defaultVal && (
            <option key="Any" value="">
              - Any -
            </option>
          )}
          {optionElements}
        </select>
        {tooltip && <Tooltip 
                id={"select-" + id + "tooltip"} 
                place="bottom"
                variant="light"
                opacity="1"
            />}
      </div>
    </div>
  );
};

export default InputSelect;
